import Text from "@ingka/text";
import { useVideoMetadataFields } from "./hooks";
import RelatedAsset from "./RelatedAsset";

type Props = {
  assetId: number;
  isLockedForOwner: boolean;
};

const OptionalFiles = ({ assetId, isLockedForOwner }: Props) => {
  const {
    canAddCaption,
    canAddSubtitles,
    canAddTranscript,
    shouldShowOptionalFiles,
  } = useVideoMetadataFields(assetId);

  if (!shouldShowOptionalFiles) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <Text tagName="h3" headingSize="xs">
        Optional additional files
      </Text>
      <div className="mt-space75 flex flex-col gap-y-space100">
         {canAddTranscript && (
           <RelatedAsset
             assetId={assetId}
             languageSelectLabel="Select transcript language"
             uploadButtonLabel="Add transcript"
             validationMessageKey="transcript"
             fileUploadType="TRANSCRIPT"
             isLockedForOwner={isLockedForOwner}
           />
         )}
         {canAddCaption && (
           <>
             <RelatedAsset
               assetId={assetId}
               languageSelectLabel="Select caption language"
               uploadButtonLabel="Add caption"
               validationMessageKey="caption"
               fileUploadType="CAPTION"
               isLockedForOwner={isLockedForOwner}
             />
           </>
         )}
         {canAddSubtitles && (
           <>
             <RelatedAsset
               assetId={assetId}
               languageSelectLabel="Select subtitles language"
               uploadButtonLabel="Add subtitles"
               validationMessageKey="subtitles"
               fileUploadType="SUBTITLE"
               isLockedForOwner={isLockedForOwner}
             />
           </>
         )}
       </div>
     </div>
   );
};

export default OptionalFiles;
